import { Moon, Sun, SunMoon } from 'lucide-solid';
import { Show, type Component } from 'solid-js';
import { useTheme } from '~/shared/lib/theme';
import { useI18n } from '~/shared/lib/i18n';
import { haptic } from '~/shared/lib/haptics';

export const ThemeToggle: Component = () => {
  const { preference, cycle } = useTheme();
  const { t } = useI18n();
  const label = () => t(`topbar.theme.${preference()}` as never) as string;

  return (
    <button
      type="button"
      class="press h-9 w-9 flex items-center justify-center rounded-md hover:bg-white/6 text-secondary"
      aria-label={`${t('topbar.theme.label')}: ${label()}`}
      title={`${t('topbar.theme.label')}: ${label()}`}
      onClick={() => {
        haptic('light');
        cycle();
      }}
    >
      <Show when={preference() === 'light'}>
        <Sun class="h-[18px] w-[18px]" />
      </Show>
      <Show when={preference() === 'dark'}>
        <Moon class="h-[18px] w-[18px]" />
      </Show>
      <Show when={preference() === 'system'}>
        <SunMoon class="h-[18px] w-[18px]" />
      </Show>
    </button>
  );
};
